import { Menu } from '@pocketlaw/tetris';
export function MenuMultiSelectItem(props) {
    const { disabled, selected = false, onClick, children, loading } = props;
    return (<Menu.ItemCheckbox disabled={disabled} loading={loading} checked={selected} onChange={onClick}>
      {children}
    </Menu.ItemCheckbox>);
}
